import { motion } from "framer-motion";
import { useLang } from "../i18n/LangContext";
import { SectionHead, Reveal } from "./Reveal";

export const Approach = () => {
  const { t } = useLang();
  return (
    <section id="approach" data-testid="approach-section" className="px-6 md:px-12 py-28 md:py-40">
      <div className="grid lg:grid-cols-12 gap-16">
        <div className="lg:col-span-5 lg:sticky lg:top-32 self-start">
          <SectionHead id="approach" over={t.approach.over} title={t.approach.title} title2={t.approach.title2} />
          <Reveal delay={0.2} className="mt-14 hidden lg:block relative aspect-[3/4] max-w-sm overflow-hidden">
            <img src="/img/suit.jpg" alt="Studio" className="w-full h-full object-cover grayscale" />
          </Reveal>
        </div>
        <ol className="lg:col-span-6 lg:col-start-7 border-t border-line">
          {t.approach.steps.map((s, i) => (
            <motion.li
              key={s.n}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.1 }}
              transition={{ duration: 0.9, delay: i * 0.08, ease: [0.7, 0, 0.2, 1] }}
              className="group py-12 border-b border-line grid grid-cols-6 gap-6"
              data-testid={`approach-step-${i}`}
            >
              <span className="col-span-1 font-display italic text-4xl md:text-5xl text-gold">{s.n}</span>
              <div className="col-span-5">
                <h3 className="font-display text-3xl md:text-4xl">{s.t}</h3>
                <p className="mt-4 text-stone leading-relaxed max-w-md">{s.d}</p>
              </div>
            </motion.li>
          ))}
        </ol>
      </div>
    </section>
  );
};
